/* eslint-disable */

export interface IntrospectionResultData {
    __schema: {
        types: {
            kind: string;
            name: string;
            possibleTypes: {
                name: string;
            }[];
        }[];
    };
}
const result: IntrospectionResultData = {
    __schema: {
        types: [
            {
                kind: 'UNION',
                name: 'StructuredBriefFields',
                possibleTypes: [
                    {
                        name: 'ProjectBriefFields',
                    },
                    {
                        name: 'SquarespaceApiBriefFields',
                    },
                    {
                        name: 'SquarespaceBriefFields',
                    },
                    {
                        name: 'PreziBriefFields',
                    },
                    {
                        name: 'SquareOnlineStoreBriefFields',
                    },
                    {
                        name: 'PacklaneBriefFields',
                    },
                    {
                        name: 'NationBuilderBriefFields',
                    },
                    {
                        name: 'SquareOnlineStoreRestaurantBriefFields',
                    },
                    {
                        name: 'WebBuilderBriefFields',
                    },
                    {
                        name: 'SquareOnlineStoreEcommerceBriefFields',
                    },
                    {
                        name: 'LogoDesignBriefFields',
                    },
                    {
                        name: 'FacebookAdBriefFields',
                    },
                    {
                        name: 'ProjectInternalBriefFields',
                    },
                    {
                        name: 'SquarespaceWebBriefFields',
                    },
                    {
                        name: 'SquarespaceApiV2BriefFields',
                    },
                    {
                        name: 'SquareOnlineSelfServeBriefFields',
                    },
                    {
                        name: 'SquareOnlineCompleteBriefFields',
                    },
                ],
            },
            {
                kind: 'UNION',
                name: 'ChatEventData',
                possibleTypes: [
                    {
                        name: 'ChatEventMessageContent',
                    },
                    {
                        name: 'ChatEventFileMessageContent',
                    },
                ],
            },
            {
                kind: 'UNION',
                name: 'ContestOverviewBriefElement',
                possibleTypes: [
                    {
                        name: 'ContestOverviewTextElement',
                    },
                    {
                        name: 'ContestOverviewTextAreaElement',
                    },
                    {
                        name: 'ContestOverviewMultipleChoiceImageElement',
                    },
                    {
                        name: 'ContestOverviewSlidersElement',
                    },
                    {
                        name: 'ContestOverviewFilesElement',
                    },
                    {
                        name: 'ContestOverviewChoiceElement',
                    },
                ],
            },
            {
                kind: 'UNION',
                name: 'OrderWorkSubItem',
                possibleTypes: [
                    {
                        name: 'OrderWorkSubItemProject',
                    },
                    {
                        name: 'OrderWorkSubItemContest',
                    },
                ],
            },
            {
                kind: 'UNION',
                name: 'ProjectContextMessageAndActions',
                possibleTypes: [
                    {
                        name: 'ContextMessageAndActionsCompletedProject',
                    },
                    {
                        name: 'ContextMessageAndActionsLockedProject',
                    },
                    {
                        name: 'ContextMessageAndActionsStartedProject',
                    },
                    {
                        name: 'ContextMessageAndActionsInvitedProject',
                    },
                ],
            },
            {
                kind: 'UNION',
                name: 'ContestContextMessageAndActions',
                possibleTypes: [
                    {
                        name: 'ContextMessageAndActionsOnHoldContest',
                    },
                    {
                        name: 'ContextMessageAndActionsRefundedContest',
                    },
                    {
                        name: 'ContextMessageAndActionsLockedContest',
                    },
                    {
                        name: 'ContextMessageAndActionsOpenContest',
                    },
                    {
                        name: 'ContextMessageAndActionsSelectingFinalistContest',
                    },
                    {
                        name: 'ContextMessageAndActionsFinalRoundContest',
                    },
                    {
                        name: 'ContextMessageAndActionsSelectingWinnerContest',
                    },
                    {
                        name: 'ContextMessageAndActionsWonContestMultipleWinners',
                    },
                    {
                        name: 'ContextMessageAndActionsWonContestSingleWinner',
                    },
                ],
            },
            {
                kind: 'UNION',
                name: 'ProjectEventContent',
                possibleTypes: [
                    {
                        name: 'AuthoriseAvailableForProfileContent',
                    },
                    {
                        name: 'RevokeAvailableForProfileContent',
                    },
                    {
                        name: 'StartAutoFinishProjectTimerContent',
                    },
                    {
                        name: 'CancelAutoFinishProjectTimerContent',
                    },
                    {
                        name: 'AutoFinishProjectReminderContent',
                    },
                    {
                        name: 'DesignTransferAgreementSignedContent',
                    },
                    {
                        name: 'ProjectDescriptionCreatedContent',
                    },
                    {
                        name: 'ProjectCreatedContent',
                    },
                    {
                        name: 'ProjectMessageContent',
                    },
                    {
                        name: 'ProjectCancelledContent',
                    },
                    {
                        name: 'ProjectUncancelledContent',
                    },
                    {
                        name: 'ProjectUnfinishedContent',
                    },
                    {
                        name: 'ProjectFinishedContent',
                    },
                    {
                        name: 'ProjectLockedContent',
                    },
                    {
                        name: 'ProjectUnlockedContent',
                    },
                    {
                        name: 'ProjectTitleUpdatedContent',
                    },
                    {
                        name: 'ProjectDetailsEditedContent',
                    },
                    {
                        name: 'ProjectFileMessageCreatedContent',
                    },
                    {
                        name: 'ProjectFolderCreatedContent',
                    },
                    {
                        name: 'ProjectFolderUpdatedContent',
                    },
                    {
                        name: 'ProjectFolderDeletedContent',
                    },
                    {
                        name: 'ProjectFileUploadedContent',
                    },
                    {
                        name: 'ProjectFileStageChangesContent',
                    },
                    {
                        name: 'ProjectDeliverableFileUploadedContent',
                    },
                    {
                        name: 'ProjectMarkDeliverableFileContent',
                    },
                    {
                        name: 'ProjectUnmarkDeliverableFileContent',
                    },
                    {
                        name: 'NoDesignerResponseContent',
                    },
                    {
                        name: 'InvoiceCreatedContent',
                    },
                    {
                        name: 'InvoiceRevisionRequestedContent',
                    },
                    {
                        name: 'InvoiceUpdatedContent',
                    },
                    {
                        name: 'InvoiceRevisedContent',
                    },
                    {
                        name: 'InvoicePaidContent',
                    },
                    {
                        name: 'InvoicePaymentHeldContent',
                    },
                    {
                        name: 'InvoiceResentContent',
                    },
                    {
                        name: 'InvoiceExpiredContent',
                    },
                    {
                        name: 'InvoiceExpirationReminderContent',
                    },
                    {
                        name: 'InvoiceCancelledContent',
                    },
                    {
                        name: 'InvoiceRefundedContent',
                    },
                    {
                        name: 'InvoiceAutoReleaseTimerStartedContent',
                    },
                    {
                        name: 'InvoiceAutoReleaseTimerCancelledContent',
                    },
                    {
                        name: 'InvoiceItemReleaseRequestDeclinedContent',
                    },
                    {
                        name: 'SuggestProjectCompletionContent',
                    },
                    {
                        name: 'ProjectEventUnknown',
                    },
                    {
                        name: 'InvoiceItemReleaseRequestedContent',
                    },
                    {
                        name: 'InvoiceItemPaymentReleasedContent',
                    },
                    {
                        name: 'InvoicePaymentReleasedContent',
                    },
                ],
            },
            {
                kind: 'UNION',
                name: 'WorkItem',
                possibleTypes: [
                    {
                        name: 'ContestWorkItem',
                    },
                    {
                        name: 'ContestDraftWorkItem',
                    },
                    {
                        name: 'ProjectWorkItem',
                    },
                    {
                        name: 'ProjectDraftWorkItem',
                    },
                    {
                        name: 'CreateBriefWorkItem',
                    },
                    {
                        name: 'OrderWorkItem',
                    },
                ],
            },
        ],
    },
};
export default result;
